import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="footer-col first">
              <h5>About Swiperyt</h5>
              <p className="p-small">
                Swiperyt is a mobile application that connects individuals to
                their possible match using our qualified matching algorithm.
              </p>
            </div>
            <div className="footer-col second">
              <h5>Contact Info</h5>
              <ul className="list-unstyled li-space-lg p-small">
                <li className="media">
                  <i className="fas fa-map-marker-alt"></i>
                  <div className="media-body">
                    2 Ayo komolafe close, isolo Lagos.
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-envelope"></i>
                  <div className="media-body">
                    <a href="#your-link">office@syncmobile.com </a>
                  </div>
                </li>
                <li className="media">
                  <i className="fas fa-phone-alt"></i>
                  <div className="media-body">
                    <a href="#your-link">+44 376 945 23</a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="footer-col third">
              <h5>Legal</h5>
              <ul className="list-unstyled li-space-lg p-small">
                <li>
                  <a href="terms-conditions.html">Terms & Conditions</a>
                </li>
                <li>
                  <a href="privacy-policy.html">Privacy Policy</a>
                </li>
                <li>
                  <a href="privacy-policy.html">Faq's</a>
                </li>
              </ul>
            </div>
            <div className="footer-col fifth">
              <span className="fa-stack">
                <a href="#your-link">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-facebook-f fa-stack-1x"></i>
                </a>
              </span>
              <span className="fa-stack">
                <a href="https://twitter.com/swiperyt_team">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-twitter fa-stack-1x"></i>
                </a>
              </span>
              <span className="fa-stack">
                <a href="#your-link">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-pinterest-p fa-stack-1x"></i>
                </a>
              </span>
              <span className="fa-stack">
                <a href="#your-link">
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fab fa-instagram fa-stack-1x"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
